import { defineStore } from 'pinia'
import * as categoryApi from '../services/api/category'

export interface ICategoryData {
  id: number
  name: string
  type: string
  parent_id: number
  children?: any[]
  image: any
}

export const useCategoryStore = defineStore('category', {
  state: () => ({
    categories: [] as ICategoryData[],
    dataTable: [] as ICategoryData[],
    dataMenu: [] as ICategoryData[],
    isLoading: false,
  }),

  actions: {
    setCategories(data: ICategoryData[]) {
      this.categories = data
    },

    setDataTable(data: ICategoryData[]) {
      // Temporarily comment out the call to getChildren due to import issue
      // getChildren(data, '')
      this.dataTable = data
    },

    setDataMenu(data: ICategoryData[]) {
      this.dataMenu = data
    },

    setLoading(value: boolean) {
      this.isLoading = value
    },

    deleteCategory(id: number) {
      this.categories = this.categories.filter((category) => category.id !== id)
    },

    async createCategory(payload: any) {
      try {
        const { data } = await categoryApi.create(payload)
        await this.listCategory()
        await this.listArrangedCategory()
        return data
      } catch (e) {
        throw new Error(String(e))
      }
    },

    async getCategory(id: number) {
      try {
        const { data } = await categoryApi.get(id)
        return data
      } catch (e) {
        throw new Error(String(e))
      }
    },

    async listCategory() {
      try {
        this.setLoading(true)
        const { data } = await categoryApi.list()
        this.setCategories(data)
        this.setLoading(false)
        return data
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async listArrangedCategory() {
      try {
        this.setLoading(true)
        const { data } = await categoryApi.list({ arranged: true })
        this.setDataTable(data)
        this.setDataMenu(data)
        this.setLoading(false)
        return data
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async updateCategory(payload: any) {
      try {
        const { data } = await categoryApi.update(payload.id, payload)
        await this.listCategory()
        await this.listArrangedCategory()
        return data
      } catch (e) {
        throw new Error(String(e))
      }
    },

    async destroyCategory(id: number) {
      try {
        const { data } = await categoryApi.destroy(id)
        this.deleteCategory(id)
        return data
      } catch (e) {
        throw new Error(String(e))
      }
    },
  },
})
